import './assets/input.css';
import { jsx as i } from "react/jsx-runtime";
import e from "clsx";
import { forwardRef as u } from "react";
const _ = "_input_1t7g3_3", m = "_input_error_1t7g3_48", r = {
  input: _,
  input_error: m
}, a = u((t, o) => {
  const { className: n, hasError: p, ...s } = t;
  return /* @__PURE__ */ i(
    "input",
    {
      className: e(r.input, { [r.input_error]: p }, n),
      ref: o,
      ...s
    }
  );
});
a.displayName = "Input";
export {
  a as Input
};
